import React from "react";

function ProductCard({ item }) {

  return (
    <div className="max-w-xs rounded shadow-lg m-4 md:m-0 md:my-6 overflow-hidden">
      <a target="_blank" rel="noreferrer" href={item.demoLink}>
        <img
          height="80"
          width="80"
          className="w-full h-64 border-b border-gray-200 object-contain cursor-pointer rounded-t transform hover:scale-110 transition ease-in duration-300"
          src={item.image}
          alt="product-card-img"
        />
      </a>
      <div className="px-6 h-32 flex flex-col justify-center items-center">
        <h2 className="font-bold text-xl mb-2 text-center">{item.title}</h2>
        <p className="text-gray-700 text-base text-center">
          {item.description}
        </p>        
      </div>
    </div >
  )
}

export default ProductCard;